export const API_PATH_apiWorkzonesAppSettingGet = '/services/workzones-management/settings';
